import * as React from 'react';
import { useIntl } from 'estafette-intl';
import { Layout } from 'ui/organisms';

export const EventLayout: React.FC = ({ children }) => {
  const { t } = useIntl();

  return <Layout title={t('calendarOfEvents')}>{children}</Layout>;
};
